// =============================================================================
// Quyền xem / chấm hồ sơ của cổng GTNS (Giải thưởng Nữ sinh).
//
// BỐI CẢNH: màn Bình chọn cho bấm vào ảnh ứng viên để mở hồ sơ. Hội đồng bình
// chọn cần ĐỌC ĐƯỢC hồ sơ (gồm cả điểm đã chấm) nhưng KHÔNG được sửa điểm hay
// duyệt hồ sơ. Vì vậy phải tách 2 quyền, đừng dùng chung một cờ:
//
//   canReviewGtns      - chấm điểm & duyệt hồ sơ (quản trị viên).
//   canViewGtnsProfile - mở xem hồ sơ người khác, rộng hơn: gồm hội đồng bình
//                        chọn, nhưng ở chế độ CHỈ ĐỌC.
//
// CẢNH BÁO: code cũ nhận diện quản trị viên bằng role.includes('gtns_admin')
// / includes('ptns_admin') và gọi .includes() TRƯỚC khi kiểm tra role tồn tại
// -> crash khi role còn undefined. Các hàm dưới đây đều an toàn với null.
// =============================================================================

import { ROLE } from '../constants/enums';

// Quản trị viên cổng GTNS. Giữ cả 'ptns_admin' (tên cũ của cổng) cho tương thích.
export const isGtnsPortalAdmin = (role) =>
  role === ROLE.SUPER_ADMIN ||
  !!role?.includes('gtns_admin') ||
  !!role?.includes('ptns_admin');

// Hội đồng BÌNH CHỌN của cổng GTNS: council (dùng chung 3 cổng) hoặc council_gtns.
export const isGtnsCouncil = (role) =>
  role === ROLE.COUNCIL || role === ROLE.COUNCIL_GTNS;

// Được chấm điểm / duyệt hồ sơ.
export const canReviewGtns = (role) => isGtnsPortalAdmin(role);

// Được MỞ XEM hồ sơ của ứng viên khác (chỉ đọc với hội đồng bình chọn).
export const canViewGtnsProfile = (role) =>
  canReviewGtns(role) || isGtnsCouncil(role);
